module.exports = __webpack_public_path__ + "static/media/SFX_Feature_Complete.2fe43766.mp3";